import React, { FC } from 'react';

import { AppFormattedMessage } from '../../../components/app-formatted-message/index';
import { useSafeConversionProgressFallback } from '../hooks/use-safe-conversion-progress-fallback';
import { useSafeConversionProgressStore } from './conversion-progress.store';

export type ConversionProgressBannerProps = {
  companyId: string;
};

export const ConversionProgressBanner: FC<ConversionProgressBannerProps> = ({ companyId }) => {
  const safeCount = useSafeConversionProgressStore((state) => state.safeIds.length);

  useSafeConversionProgressFallback(companyId);

  if (safeCount < 1) return null;

  return (
    <div className="flex w-full flex-col gap-1 rounded-lg border border-brand-200 bg-brand-25 px-4 py-3">
      <div className="flex items-center justify-between gap-2">
        <span className="text-sm font-[500] text-brand-800">
          <AppFormattedMessage id="CONVERTING_SAFES" values={{ count: safeCount }} />
        </span>
        <span className="text-xs font-[450] text-brand-600">
          <AppFormattedMessage id="CONVERSION_IN_PROGRESS_HINT" />
        </span>
      </div>
      <div className="h-1.5 w-full overflow-hidden rounded-full bg-brand-100">
        <div
          aria-valuetext="indeterminate"
          className="h-full w-full animate-pulse rounded-full bg-brand-500"
          role="progressbar"
        />
      </div>
    </div>
  );
};
